import { useCallback, useState } from 'react';
import { Stack } from '@mui/material';
import Loading from '../../components/common/Loading.component';
import { useDispatch, useSelector } from 'react-redux';
import Alert from '../../components/common/Alert.component';
import ActionView from '../../views/Action.view';
import { fetchAPI } from '../../api/request';
import _ from 'lodash';

const ActionTemplate = ({ tag, action, list, query }) => {
  const { jwt } = useSelector((state) => state.login);
  const dispatch = useDispatch();
  const userAuth = useSelector((state) => state.login?.user);

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const onError = useCallback((err) => {
    setSuccess(false);
    setLoading(false);
    setError(err?.response?.data?.error?.message || 'An error has occurred');
    // eslint-disable-next-line
  }, []);

  const onSuccess = useCallback(() => {
    setSuccess(true);
    setLoading(false);
    setError(null);

    if (list?.actions?.resetSelect) {
      setTimeout(() => dispatch(list.actions.resetSelect()), 1000);
    }
  }, [setLoading, setSuccess, list, dispatch]);

  const onSubmit = useCallback(
    (values) => {
      if (userAuth.permissions[_.toUpper(tag)]?.UPDATE === 'true') {
        setError(null);
        setSuccess(false);
        setLoading(true);
        fetchAPI(
          query.action.settings,
          {},
          '',
          {
            ...values,
          },
          jwt
        )
          .then(onSuccess)
          .catch(onError);
      }
    },
    [setLoading, jwt, onSuccess, onError, query, tag, userAuth]
  );

  return (
    <Stack spacing={2} justifyContent='center' alignItems='center' width={1}>
      {loading && <Loading />}
      {success && (
        <Alert severity='success'>{'Success: Updated all items'}</Alert>
      )}
      {error && <Alert severity='error'>{error}</Alert>}

      <ActionView
        tag={tag}
        action={action}
        list={list}
        onSubmitAction={onSubmit}
        success={success}
      />
    </Stack>
  );
};

export default ActionTemplate;
